import { dashboardDetailsConstants } from "../constants";
import { alertActions } from ".";
import { dashboardDetailService } from "../services/dashboardDetailService";

export const dashboardDetailActions = {
  loadingData,
  fetchDashboardData
};
function fetchDashboardData(obj) {
  return (dispatch) => {
    dispatch(request());
    dashboardDetailService.fetchDashboardData(obj).then(
      (response) => {
        dispatch(loadingData(false));
        dispatch(success(response.ResponseData));
      },
      (error) => {
        dispatch(loadingData(false));
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: dashboardDetailsConstants.GETALL_REQUEST };
  }
  function success(data) {
    return { type: dashboardDetailsConstants.GETALL_SUCCESS, data };
  }
  function failure(error) {
    return { type: dashboardDetailsConstants.GETALL_FAILURE, error };
  }
}

function loadingData(isbool) {
  return {
    type: dashboardDetailsConstants.LOADING_REQUEST,
    isbool
  };
}
